import { render, staticRenderFns } from "./GameRuleEditComponent.vue?vue&type=template&id=9114200e&scoped=true"
import script from "./GameRuleEditComponent.vue?vue&type=script&lang=js"
export * from "./GameRuleEditComponent.vue?vue&type=script&lang=js"
import style0 from "./GameRuleEditComponent.vue?vue&type=style&index=0&id=9114200e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9114200e",
  null
  
)

export default component.exports